// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2EtGu","clinicsSelect":"styles_clinicsSelect__3snP-"};